import { useEffect } from 'react';

import { buildTownSquareUrl } from '../utils';

/**
 * Client `/profile` is no longer an editor.
 *
 * Every field it used to edit is now edited inline on the Town Square profile
 * page (display name, bio, artist statement, story, avatar, banner, location,
 * categories, social links, artwork details, gallery upload and reorder), the
 * owner controls live in the profile's owner bar, and the preview iframe is
 * replaced by view-as-public. The account-level leftovers (name, email,
 * watermark) moved to client `/settings`.
 *
 * The redirect is a full-document `window.location.replace`, not React Router's
 * `<Navigate replace />`: the destination is the Town Square origin
 * (`__TOWN_SQUARE_URL__`), and `<Navigate>` only rewrites this SPA's history
 * entry — it cannot leave the origin. `replace` (not `assign`) keeps the
 * retired URL out of session history so Back does not bounce straight into the
 * redirect again, which is the same intent as the `<Navigate replace />` calls
 * used for the in-app redirects in `App.tsx`.
 *
 * `buildTownSquareUrl` adds the viewer's locale prefix, so a non-English owner
 * lands on their own locale without a middleware bounce. The destination needs
 * no slug: Town Square `/profile` resolves the signed-in owner itself.
 *
 * Both apps' sidebars and headers now link straight to Town Square `/{slug}`,
 * so this route only serves inbound deep links and bookmarks — not our own
 * chrome. It is also still in `SELF_HANDLED_PREFIXES`
 * (`components/featureWizard/constants.ts`), which is signed-out routing, not a
 * wizard destination.
 */
export default function ProfileRedirect() {
  useEffect(() => {
    window.location.replace(buildTownSquareUrl('/profile'));
  }, []);

  return null;
}
